import { Box, Stack, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export const NoPermissionMessage = ({
  message = "You don't have permission to view this page.",
}: { message?: string }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "60vh",
      p: 4,
    }}
  >
    <Stack spacing={2} alignItems="center" textAlign="center" maxWidth={520}>
      <LockOutlinedIcon sx={{ fontSize: 56, color: "text.secondary" }} />
      <Typography variant="h6">Restricted Access</Typography>
      <Typography variant="body2" color="text.secondary">
        {message}
        {" "}If you believe this is a mistake, contact your administrator.
      </Typography>
    </Stack>
  </Box>
);
